var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class MouseCursor extends Component {
    constructor(isDebugEnabled = false) {
        super('MouseCursor', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            MouseCursor.cursorElement = $.parseHTML('<div class="mouse-cursor d-none"><div class="spinner-border"></div></div>');
            $('body').append(MouseCursor.cursorElement);
            $(window).on('mousemove', MouseCursor.mouseMoveHandler);
            MouseCursor.update();
            this.success();
        });
    }
    static setDotPosition(position) {
        MouseCursor.cursorElement.css({
            left: position.x,
            top: position.y,
        });
    }
    static mouseMoveHandler(event) {
        MouseCursor.cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
    }
    static update() {
        if (MouseCursor.isLoading) {
            MouseCursor.setDotPosition(MouseCursor.cursorPosition);
        }
        requestAnimationFrame(MouseCursor.update);
    }
    static setLoadingState(isLoading) {
        if (isLoading === false) {
            setTimeout(() => {
                MouseCursor.isLoading = isLoading;
                MouseCursor.cursorElement.addClass('d-none');
                $('body').removeClass('no-cursor');
            }, 500);
        }
        else {
            MouseCursor.isLoading = isLoading;
            MouseCursor.cursorElement.removeClass('d-none');
            $('body').addClass('no-cursor');
        }
    }
}
MouseCursor.isLoading = true;
MouseCursor.cursorPosition = { x: 0, y: 0 };
